import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from "../config";

const CompaniesBlogsResources = () => {
  const [banner, setBanner] = useState(null);
  const [blogs, setBlogs] = useState([]);

  // Fetch banner
  useEffect(() => {
    fetch(
      "/prosapiens-cms/public/api/banners/blog-or-resources"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.banners && data.banners.length > 0) {
          setBanner(data.banners[0]);
        }
      })
      .catch((err) => console.error("Error fetching banner:", err));
  }, []);

  // Fetch blogs
  useEffect(() => {
    fetch(
      "/prosapiens-cms/public/api/content/blog-or-resources"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.content && data.content.length > 0) {
          setBlogs(data.content);
        }
      })
      .catch((err) => console.error("Error fetching blogs:", err));
  }, []);

  return (
    <>
      {/* Banner */}
      {banner && (
        <section
          className="blog-bg resources-mobile"
          style={{
            backgroundImage: `url(/prosapiens-cms/public/${banner.banner_image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="overlay container" style={{ color: "#fff" }}>
            <div dangerouslySetInnerHTML={{ __html: banner.content_text }} />
          </div>
        </section>
      )}

      {/* Blogs */}
      <div className="container">
        <div className="blog-grid">
          {blogs.map((blog) => (
            <div className="blog-card" key={blog.id}>
              <Link to={`/blogs/${blog.id}`}>
                <div className="blog-content">
                  <div
                    className="blog-excerpt"
                    dangerouslySetInnerHTML={{ __html: blog.content_text }}
                  />
                  {blog.content_image && (
                    <div className="blog-image">
                      <img
                        src={`/prosapiens-cms/public/${blog.content_image}`}
                        alt={blog.content_title}
                      />
                    </div>
                  )}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CompaniesBlogsResources;
